import { render, staticRenderFns } from "./screen.vue?vue&type=template&id=1aa08ebb&scoped=true&"
import script from "./screen.vue?vue&type=script&lang=ts&"
export * from "./screen.vue?vue&type=script&lang=ts&"
import style0 from "./screen.vue?vue&type=style&index=0&id=1aa08ebb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa08ebb",
  null
  
)

export default component.exports